import { formatarDocumento } from "../../../util/masks";
export const COLUMNS = [
  {
    Header: "CPF/CNPJ",
    accessor: "cpf",
    Cell: ({ value }) => {
      return formatarDocumento(value);
    },
  },
  {
    Header: "Nome",
    accessor: "nome",
  },
  {
    Header: "E-mail",
    accessor: "email",
    sortType: (rowA, rowB, columnId) => {
      const a = (rowA.values[columnId] || "").toLowerCase();
      const b = (rowB.values[columnId] || "").toLowerCase();
      return a.localeCompare(b);
    },
  },
  {
    Header: "Perfil",
    accessor: "perfil",
  },
  {
    Header: "Status",
    accessor: "ativo",
    Cell: ({ value }) => {
      return value ? "Ativo" : "Inativo";
    },
    sortType: (rowA, rowB, columnId) => {
      return rowA.values[columnId] === rowB.values[columnId]
        ? 0
        : rowA.values[columnId]
        ? -1
        : 1;
    },
  },
];
export const COLUMNS_LOGS = [
  { Header: "Data e Hora", accessor: "dataHora" },
  { Header: "Responsável", accessor: "responsavel" },
  { Header: "IP", accessor: "ip" },
  { Header: "Tipo", accessor: "tipo" },
  { Header: "Descrição", accessor: "descricao" },
];
